//export const basePath = "http://localhost:4200/api";
export const basePath = 'https://api-crm.avestruz.mx/api';
export const apiVersion = 'v1';
